// extracted by mini-css-extract-plugin
export var box = "Tabs-module--box--c3673";
export var box_md = "Tabs-module--box_md--12b6f";
export var box_xmd = "Tabs-module--box_xmd--e19db";
export var box_flex = "Tabs-module--box_flex--68b76";
export var box_lg = "Tabs-module--box_lg--9f1d4";
export var box_sm = "Tabs-module--box_sm--f8c68";
export var box_outer = "Tabs-module--box_outer--7e156";
export var box_whiteBg = "Tabs-module--box_white-bg--56316";
export var box_noMarginBottom = "Tabs-module--box_no-margin-bottom--fc0c4";
export var box_noPadding = "Tabs-module--box_no-padding--cec0f";
export var box_outerGray = "Tabs-module--box_outer-gray--8a1ba";
export var box_dark = "Tabs-module--box_dark--42ccd";
export var box_zIndex = "Tabs-module--box_z-index--e28b5";
export var box_zIndex6 = "Tabs-module--box_z-index-6--0e20c";
export var box_eventsWithLine = "Tabs-module--box_events-with-line--c2fe0";
export var box_featuresAo = "Tabs-module--box_features-ao--937b9";
export var box_verticalPaddings = "Tabs-module--box_vertical-paddings--89875";
export var clearP = "Tabs-module--clearP--5fb72";
export var clearP_vc = "Tabs-module--clearP_vc--0aa3f";
export var buttonRow = "Tabs-module--buttonRow--1c390";
export var alumni = "Tabs-module--alumni--a6960";
export var button = "Tabs-module--button--7c163";
export var line = "Tabs-module--line--4abb3";
export var hidden = "Tabs-module--hidden--62262";
export var fadeInAnimation = "Tabs-module--fadeInAnimation--6b303";
export var placeHolderShimmer = "Tabs-module--placeHolderShimmer--323f2";